module.exports = __webpack_public_path__ + "img/dept_5_market.9dab2028.png";